import { Component, OnInit, Input } from '@angular/core';
import $ from 'jquery';
import { GoogleAnalyticsService } from 'src/app/main/services/google-analytics.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  imagesUrl = environment.imagesUrl;
  @Input() logoImg: string;

  @Input() navItemList: any[];

  @Input() className: string;

  @Input() styledLogo = true;

  @Input() logoWhite: string;
  @Input() logoClass: string;

  constructor(private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit() {
  }

  jumpTo(href) {
    $('html, body').stop().animate({
      scrollTop: $(href).offset().top
    }, 1500);
  }

  toggleClass() {
    $(".menu-btn").click(function () {
      $(this).toggleClass("is-active");
    });
  }
  clickOnMenuItem(title) {
    this.googleAnalyticsService.eventEmitter('Click on menu item', 'home page', 'click on menu item - ' + title)

  }
}
